import { Box, Button, useMediaQuery } from "@material-ui/core";
import { Link } from "react-router-dom";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";

import { useStyles } from "../checkoutPage.styles";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { openSummary } from "../../../store/checkoutPage.slide";
import { RootState } from "../../../app/rootReducer";
import { solarGrantAmountAvailable } from "../../../app/utils";
import { PriceFormat } from "../../../components/typography/PriceFormat";

export const Header = ({ rendered }: { rendered: boolean }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isMoreThanSm, isMoreThanMd } = useBreakpoint();
  const matchesSmallMobile = useMediaQuery("(max-width:360px)");
  const { quote, solarReport } = useSelector((state: RootState) => state.quote);

  return (
    <Box
      py={isMoreThanSm ? "33px" : "24px"}
      px={matchesSmallMobile ? "12px" : 0}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bgcolor={!isMoreThanSm ? "#fff" : "transparent"}
    >
      <Link to="/">
        <img className={classes.logo} src={process.env.PUBLIC_URL + "/images/logo.png"} alt="Logo" />
      </Link>
      {!isMoreThanMd && rendered && (
        <Button
          variant="outlined"
          className={classes.summaryButton}
          onClick={() => {
            dispatch(openSummary());
          }}
        >
          <Box display={"flex"} width={"100%"} alignItems={"center"} justifyContent={"space-between"}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"start"}>
              <Box fontSize={"8px"} mt="8px" fontWeight={500} color="#4b5462">
                Summary
              </Box>
              <Box fontSize={"18px"} fontWeight={500} color="#43335b">
                <PriceFormat value={Number(quote?.price ?? 0) - solarGrantAmountAvailable(quote, solarReport)} />
              </Box>
            </Box>
            <ArrowDropDownIcon />
          </Box>
        </Button>
      )}
    </Box>
  );
};
